import React, { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import {
  findGlobalPostsForPostTemplateInitiated,
  getFacebookPostInitiated
} from '../../../../store/dashboard/dashboard.actions'
import { Theme } from '@mui/material'

import { getTheme, getUser, namedRequestStatus } from '../../../../store/common/common.selectors'
import {
  DeferredPost,
  FindGlobalPostsForPostTemplateResponse,
  NetworkType,
  PublishedPost
} from '@3m5/sm_publish-frontend-api'
import Preloader from '@professocial/professocialFormComponents/FormComponents/Preloader'
import { CoreRootState } from '../../../../store/coreRoot.reducer'
import NoDataComponent from '@professocial/professocialFormComponents/FormComponents/NoDataComponent'
import EditorDashboardDetailsPost from './EditorDashboardDetailsPost'
import { GetFacebookPostRequest } from '@3m5/sm_publish-frontend-api'
import { ColorKeysWithId } from '../subScreens/EditorDashboardDetails'

interface IProps {
  data?: FindGlobalPostsForPostTemplateResponse;
  colored?: ColorKeysWithId[];
}

const FacebookDetailsTab: React.FC<IProps> = (props) => {
  const { t } = useTranslation()
  const dispatch = useDispatch()

  const user: any = useSelector(getUser)
  const theme: Theme = useSelector(getTheme)

  const statusOnGlobalPosts: string | undefined = useSelector((state: CoreRootState) => namedRequestStatus(state, findGlobalPostsForPostTemplateInitiated.type))

  const dispatchGetFacebookPost = useCallback((params: GetFacebookPostRequest) => dispatch(getFacebookPostInitiated(params)), [dispatch])

  const handleGetFacebookPost = (posting: PublishedPost) => {
    const { networkPostId, networkPageId, networkType } = posting
    if (networkType === NetworkType.Facebook) {
      dispatchGetFacebookPost({
        networkPageId: networkPageId,
        networkPostId: networkPostId,
      })
    }
  }

  return (
    <>
      {user && props.data && (props.data.deferredPosts.length > 0 || props.data.publishedPosts.length > 0) ? (
        <>
          {
            props.data.publishedPosts && props.data.publishedPosts.map((posting: PublishedPost, index: number) => {
              return (
                <React.Fragment key={index}>
                  {posting &&
                    <EditorDashboardDetailsPost
                      theme={theme}
                      user={user}
                      networkType={NetworkType.Facebook}
                      publishedPost={posting}
                      colored={props.colored}
                      getFacebookPost={handleGetFacebookPost}
                    />}
                </React.Fragment>
              )
            })
          }
          {
            props.data.deferredPosts && props.data.deferredPosts.map((posting: DeferredPost, index: number) => {
              return (
                <React.Fragment key={index}>
                  {posting &&
                    <EditorDashboardDetailsPost
                      theme={theme}
                      user={user}
                      deferredPost={posting}
                      colored={props.colored}
                    />}
                </React.Fragment>
              )
            })
          }
        </>
      ) : statusOnGlobalPosts === 'success' ?
        <NoDataComponent noDataText={t('networkContentMessages:noPostsYet')} alignment="center" margin="16px 0"/> :
        <Preloader/>}
    </>
  )
}

export default FacebookDetailsTab
